import {
  Box,
  Collapse,
  Drawer,
  Icon,
  IconButton,
  Paper,
  useTheme,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
// import CustomTreeView from "./customTreeView";
import { cloneElement, JSX, useState } from "react";
import useStyles from "./styles";
import CustomTreeView from "./customTreeView";
import { useNavigate } from "react-router-dom";
import { useTemplate } from "../../context/templateContext";

////////////////////////////////////////////////////////////////////////////////////////////////////////////
//este componente está diferente do cliente poir causa da recursividae de problemas tom o TreeViewProvider//
////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface SideBarProps {
  openRightBar: boolean;
  setOpenRightBar: React.Dispatch<React.SetStateAction<boolean>>;
  openDrawer: boolean;
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  iconLogo: JSX.Element;
  paginas: Dash[];
  ocultar?: boolean;
  backgroundColor?: string | null;
  titlePage?: string;
  setTitlePage?: React.Dispatch<React.SetStateAction<string>>;
  link?: string;
  setLink?: React.Dispatch<React.SetStateAction<string>>;
  pageConfig?: boolean;
  hideSideBar: boolean;
  setHideSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  hideTopBar: boolean;
  setHideTopBar: React.Dispatch<React.SetStateAction<boolean>>;
}

function SideBar(props: SideBarProps): JSX.Element {
  const { initialPathName } = useTemplate();
  const {
    openRightBar,
    setOpenRightBar,
    openDrawer,
    setOpenDrawer,
    iconLogo,
    ocultar = false,
    backgroundColor = null,
    pageConfig,
    hideSideBar,
    setHideSideBar,
    hideTopBar,
    setHideTopBar,
  } = props;

  const theme = useTheme();
  const navigate = useNavigate();
  const colorMode = theme.palette.mode;

  const styles = useStyles(theme, colorMode, backgroundColor);

  const handleDrawerToggle = () => {
    setOpenDrawer((prevState) => !prevState);
  };
  const [openPaper, setOpenPaper] = useState(false);
  // useEffect(() => {
  //   if (!openRightBar) {
  //     setOpenPaper(false);
  //   }
  // }, [openRightBar]);
  const widthRightBar = (open: boolean) => (open ? 270 : 56);

  const customIconLogo = cloneElement(iconLogo, {
    style: {
      width: "116px",
      fill: "#FFFFFF",
      height: "auto",
      cursor: "pointer",
    },
    //className: "custom-svg",
    role: "img",
    onClick: (e: React.MouseEvent) => {
      navigateToHome();
    },
  });

  function navigateToHome() {
    window.location.pathname = initialPathName || "/";
  }
  // const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  // const isLg = useMediaQuery(theme.breakpoints.only("lg"));

  return (
    <>
      <Drawer
        variant="temporary"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        sx={styles.drawer}
      >
        <>
          <Box sx={styles.boxMenuAndLogo}>
            <IconButton
              sx={styles.buttonMenuDawer}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
            <IconButton sx={styles.iconLogo}>{customIconLogo}</IconButton>
            {/* {!isXs && !isLg && (
              <IconButton
                sx={styles.buttonMenuDawer}
                disableRipple
                onClick={() => {
                  setHideSideBar(!hideSideBar);
                  setHideTopBar(!hideTopBar);
                }}
              >
                {hideSideBar && hideTopBar ? (
                  <OpenInFull />
                ) : (
                  <CloseFullscreen />
                )}
              </IconButton>
            )} */}
          </Box>
          <CustomTreeView
            ocultar={ocultar}
            open={openDrawer}
            setOpen={setOpenDrawer}
            closeOnClickItem
            {...props}
          />
        </>
      </Drawer>
      {!ocultar && (
        <Paper
          sx={styles.paper}
          variant="outlined"
          onMouseEnter={() => setOpenPaper(true)}
          onMouseLeave={() => setOpenPaper(false)}
        >
          <Collapse
            in={openRightBar ? openRightBar : openPaper}
            //in={openRightBar}
            orientation="horizontal"
            collapsedSize={widthRightBar(false)}
            timeout={300}
          >
            <Box sx={{ height: "calc( 100vh - 65px)", overflow: "auto" }}>
              <Box sx={styles.boxMenuAndLogo}>
                {/* <IconButton
                  sx={styles.buttonMenuDawer}
                  disableRipple
                  onClick={() => {
                    setHideSideBar(!hideSideBar);
                    setHideTopBar(!hideTopBar);
                  }}
                >
                  <MenuIcon />
                </IconButton> */}
                <Icon sx={styles.iconLogo}>{customIconLogo}</Icon>
              </Box>
              <CustomTreeView
                ocultar={ocultar}
                open={openRightBar ? openRightBar : openPaper}
                pageConfig={pageConfig}
                //open={openRightBar}
                setOpen={setOpenRightBar}
                {...props}
              />
            </Box>
          </Collapse>
        </Paper>
      )}
    </>
  );
}
export default SideBar;
